'use strict';

exports.__esModule = true;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _context4 = require('@prisma-cms/context');

var _context5 = _interopRequireDefault(_context4);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _PersonAdd = require('material-ui-icons/PersonAdd');

var _PersonAdd2 = _interopRequireDefault(_PersonAdd);

var _Undo = require('material-ui-icons/Undo');

var _Undo2 = _interopRequireDefault(_Undo);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatRoomAddMember = (_temp2 = _class = function (_Component) {
  _inherits(ChatRoomAddMember, _Component);

  function ChatRoomAddMember() {
    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomAddMember);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      value: undefined,
      opened: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ChatRoomAddMember.prototype.render = function render() {
    var _this2 = this;

    var _context = this.context,
        Grid = _context.Grid,
        UserAutocomplete = _context.UserAutocomplete,
        currentUser = _context.user;
    var _state = this.state,
        value = _state.value,
        opened = _state.opened;
    var ChatRoom = this.props.ChatRoom;

    var _ref = ChatRoom || {},
        roomId = _ref.id,
        Members = _ref.Members,
        Invitations = _ref.Invitations;

    var _ref2 = currentUser || {},
        currentUserId = _ref2.id;

    if (!roomId || !currentUserId || !Members || Members.findIndex(function (n) {
      return n.id === currentUserId;
    }) === -1) {
      return null;
    }

    var content = null; // console.log("Invitations", Invitations);

    if (opened) {
      var exclude = Members.map(function (_ref3) {
        var id = _ref3.id;
        return id;
      }).concat(Invitations.map(function (n) {
        return n.User.id;
      })).concat([currentUserId]); // console.log("exclude", exclude);

      content = _react2.default.createElement(Grid, {
        container: true,
        alignItems: 'center'
      }, _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(_IconButton2.default, {
        onClick: function onClick() {
          return _this2.setState({
            opened: false
          });
        }
      }, _react2.default.createElement(_Undo2.default, null))), _react2.default.createElement(Grid, {
        item: true
      }, _react2.default.createElement(UserAutocomplete, {
        where: {
          id_not_in: exclude
        },
        value: value || "" // value="cjqbpqrrw4mrc0860wyktotnn"
        ,
        onDelete: value ? function (event) {
          _this2.setState({
            value: undefined
          });
        } : undefined,
        saveHandler: value ? function () {
          var _ref4 = _asyncToGenerator(
          /*#__PURE__*/
          _regenerator2.default.mark(function _callee(event) {
            var _context2, inviteChatRoomProcessor, client;

            return _regenerator2.default.wrap(function _callee$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // updateObject({
                    //   blogID: undefined,
                    // })
                    _context2 = _this2.context, inviteChatRoomProcessor = _context2.query.inviteChatRoomProcessor, client = _context2.client;
                    _context3.next = 3;
                    return client.mutate({
                      mutation: (0, _graphqlTag2.default)(inviteChatRoomProcessor),
                      variables: {
                        data: {
                          User: {
                            id: value
                          }
                        },
                        where: {
                          id: roomId
                        }
                      }
                    }).then(function (r) {
                      _this2.setState({
                        value: undefined,
                        opened: false
                      });
                    }).catch(console.error);

                  case 3:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee, _this2);
          }));

          return function (_x) {
            return _ref4.apply(this, arguments);
          };
        }() : undefined,
        onSelect: function onSelect(value, item) {
          // console.log("onSelect", value, item);
          var id = item.id;

          _this2.setState({
            value: id || undefined
          });
        }
      })));
    } else {
      content = _react2.default.createElement(_IconButton2.default, {
        title: "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
        onClick: function onClick() {
          return _this2.setState({
            opened: true
          });
        }
      }, _react2.default.createElement(_PersonAdd2.default, null));
    }

    return content;
  };

  return ChatRoomAddMember;
}(_react.Component), _class.contextType = _context5.default, _temp2);
ChatRoomAddMember.propTypes = process.env.NODE_ENV !== "production" ? {
  ChatRoom: _propTypes2.default.object.isRequired
} : {};
exports.default = ChatRoomAddMember;
module.exports = exports['default'];